import { Component } from '@angular/core';

@Component({
  selector: 'hx-promo-hero',
  standalone: true,
  template: `
    <header class="promo-hero wrap">
      <p class="eyebrow" style="justify-content:center">Promotions &amp; Referrals</p>
      <h1>Good work travels. <br />So do the rewards.</h1>
      <p>Current offers for new projects, and a referral program for every business you send our way.</p>
    </header>
  `,
})
export class PromoHeroComponent {}
